import React, { useEffect } from "react";
import styles from "./Bootcamps.module.css";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { useState } from "react";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { GetCategories } from "../../../store/categories-store/categories-actions";
import { GetCourses } from "../../../store/course-store/course-actions";
import Loading from "../../../components/loading/Loading";

const Bootcamps = () => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1024);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 1200);
  const [isMobile, setIsMobile] = useState(window.innerWidth > 480)
  const courses = useSelector((state) => state.course.courses);
  const categories = useSelector((state) => state.category.categories);
  const dispatch = useDispatch();
  const [currentFilter, setCurrentFilter] = useState("");
  const [filteredCourses, setFilteredCourses] = useState([]);  

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1200);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth < 1200);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 520);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (
      categories !== null &&
      categories !== undefined &&
      categories.length === 0
    ) {
      dispatch(GetCategories("jmiranda@aba.org.do", false));
    }
  });

  useEffect(() => {
    if (courses !== null && courses !== undefined && courses.length === 0) {
      dispatch(GetCourses("jmiranda@aba.org.do", false));
    }
  });

  useEffect(() => {
    const FC = courses
      ? courses.filter((course) => {
          return (
            course.categoryId === currentFilter.id && course.status === true 
          );
        })
      : null;
    if (
      (FC !== null && FC !== undefined && FC.length === 0) ||
      currentFilter.id === 3 
    ) {      
      setFilteredCourses(courses
        ? courses.filter(
            (course) => course.status === true && course.courseTypeId === 6
          )
        : []
      );
    } else {

      setFilteredCourses(FC);
    }
  },[courses]);

  const [layout, setLayout] = useState("grid");

  const listItem = (course, index) => {
    return (
      <div onClick={() => {
        window.location.href = `/courseinfo/${course.id}`;
      }} className="col-12" key={course.id}>
        <div
          className={classNames(
            "flex flex-column xl:flex-row xl:align-items-start p-4 gap-4",
            { "border-top-1 surface-border": index !== 0 }
          )}
        >
          <img
            className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round"
            src={course.imageUrl}
            alt={course.topic}
          />
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
              <div className="text-2xl font-bold text-900">{course.topic}</div>

              <div className="flex align-items-center gap-3">
                <p className={styles.cardDescription}>
                  {formatTextList(course.shortDescription)}
                </p>
                <span className="flex align-items-center gap-2"></span>
              </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2" style={isWideScreen || isMobile || isTablet ? { } : { marginLeft: "50vw", marginTop: "10vh" }}>
              <span className="text-2xl font-semibold" style={isWideScreen ? {} : {marginTop: "10vw"}}>{course.courseTypeId !== 3 ? "US$" + course.price  : "Gratis"}</span>
              <Button
                icon="pi pi-chevron-right"
                className="p-button-rounded"
                onClick={() => {
                  window.location.href = `/courseinfo/${course.id}`;
                }}
              ></Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const formatText = (text) => {
    const maxLength = 103;

    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }

    return text;
  };

  const formatTextList = (text) => {
    const maxLength = 150;

    if (text.length > maxLength) {
      return text.substring(0, maxLength - 3) + "...";
    }

    return text;
  };

  const cardHeader = (img) => {
    return (
      <div className={styles.cardHeaderContainer}>
        <img alt="Card" src={img} className={styles.cardHeader} />
      </div>
    );
  };

  const cardFooter = (course) => {
    return <span className={styles.cardFooter}>{course.courseTypeId !== 3 ? "US$" + course.price : "Gratis"}</span>;
  };

  const gridItem = (course) => {
    return (
      <Card
        title={course.topic}
        subTitle={
          <span className={styles.cardSubtitle}>
            {course.courseCategory.category}
          </span>
        }
        className={styles.cardGridItem}
        style={!isWideScreen ? { width: "100%", height: "auto" } : {}}
        header={cardHeader(course.imageUrl)}
        footer={cardFooter(course)}
        emptyMessage="No se encontró ningún curso."
        onClick={() => {
          window.location.href = `/courseinfo/${course.id}`;
        }}
      >
        <p className={styles.cardDescription}>
          {formatText(course.shortDescription)}
        </p>
      </Card>
    );
  };

  const itemTemplate = (course, layout, index) => {
    if (!course) {
      return;
    }

    if (layout === "list" || !isWideScreen) return listItem(course, index);
    else if (layout === "grid") return gridItem(course);
  };

  const listTemplate = (courses, layout) => {
    return (
      <div className="grid grid-nogutter">
        {courses.map((course, index) => itemTemplate(course, layout, index))}
      </div>
    );
  };

  const header = () => {
    return (
      <div className={styles.header}>
        <h1 className={styles.headerTitle}>Bootcamps</h1>
        <div className={styles.options}>
          {/* <Dropdown
            value={currentFilter}
            options={categories}
            optionLabel="category"
            onChange={(e) => setCurrentFilter(e.value)}
            placeholder="Filtros"
            className={styles.filterDropdown}
            filterIcon="pi pi-filter"
          />
          {isWideScreen && (
            <DataViewLayoutOptions
              layout={layout}
              onChange={(e) => setLayout(e.value)}
              className={styles.layoutOptions}
            />
          )} */}
        </div>
      </div>
    );
  };

  return (
    <>
      {(courses === undefined || courses <= 0) && (
        <>
          <Loading />
        </>
      )}
      {filteredCourses !== undefined && filteredCourses !== null && filteredCourses.length > 0 && (
        <div className={styles.dataViewContainer}>
          <DataView
            value={filteredCourses}
            listTemplate={listTemplate}
            layout={layout}
            header={header()}
            paginator
            rows={8}
            sortField="id"
            sortOrder={-1}
            emptyMessage="No hay ningún Bootcamp disponible en este momento."
          />
        </div>
      )}
      {filteredCourses === undefined || filteredCourses == null || filteredCourses.length < 1 && (
          <div className="h-screen flex flex-column justify-content-center align-items-center noCoursesMessage">
            <span className={`col-9 ${styles.noCoursesMessage}`}>
             
            No hay ningún Boocamp disponible en este momento. Vuelve más tarde.
            </span>
          </div>
      )}
    </>
  );
};

export default Bootcamps;
